import _implicitStylesheets from "./tag.css";
import _implicitScopedStylesheets from "./tag.scoped.css?scoped=true";
import _axTag from "ax/tag";
import _wdsAnalyticsInstrument from "wds/analyticsInstrument";
import {freezeTemplate, registerTemplate} from "lwc";
const stc0 = {
  "type": "tag"
};
function tmpl($api, $cmp, $slotset, $ctx) {
  const {b: api_bind, c: api_custom_element} = $api;
  const {_m0, _m1} = $ctx;
  return [api_custom_element("wds-analytics-instrument", _wdsAnalyticsInstrument, {
    props: stc0,
    key: 0,
    on: {
      "analytics": _m0 || ($ctx._m0 = api_bind($cmp.handleAnalytics))
    }
  }, [api_custom_element("ax-tag", _axTag, {
    props: {
      "href": $cmp.href,
      "ariaLabel": $cmp.ariaLabel,
      "ariaLive": $cmp.ariaLive,
      "text": $cmp.text,
      "variant": $cmp.variant,
      "disabled": $cmp.disabled
    },
    key: 1,
    on: {
      "click": _m1 || ($ctx._m1 = api_bind($cmp.handleClick))
    }
  })])];
  /*LWC compiler v7.1.3*/
}
export default registerTemplate(tmpl);
tmpl.stylesheets = [];
tmpl.stylesheetToken = "lwc-5tqg8q9644s";
tmpl.legacyStylesheetToken = "undefined-_tag";
if (_implicitStylesheets) {
  tmpl.stylesheets.push.apply(tmpl.stylesheets, _implicitStylesheets);
}
if (_implicitScopedStylesheets) {
  tmpl.stylesheets.push.apply(tmpl.stylesheets, _implicitScopedStylesheets);
}
freezeTemplate(tmpl);
